import type { IOrdinalProvenanceResponse } from 'api/api'

export const ORDINAL_PROVENANCE_RETRY_MS = {
    pending: 5_000,
    stale: 30_000,
    error: 60_000,
} as const

export function ordinalProvenanceRetryDelayMs(
    provenance: IOrdinalProvenanceResponse | null,
): number | null {
    const status = provenance?.chain?.status
    if (!status || status === 'fresh') return null
    return ORDINAL_PROVENANCE_RETRY_MS[status]
}
